import { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

import { ButtonSplitGroup, ExportToCSVButton } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';

const renderActionsCell = ({ row }) => {
  const navigate = useNavigate();
  const { invoiceID } = row.values;
  const { pdf_location: pdfLocation } = row.original;
  return (
    <ButtonSplitGroup>
      <Button
        className="btn-sm"
        variant="didxl"
        as="a"
        href={pdfLocation}
        target="_blank"
        size="sm"
      >
        PDF
      </Button>
      <Button
        className="btn-sm"
        variant="didxl"
        onClick={() => navigate(`/billing/invoices/${invoiceID}/details`)}
        size="sm"
      >
        Details
      </Button>
    </ButtonSplitGroup>
  );
};

const renderInvoiceNumber = ({ row, value }) => {
  const { invoiceID } = row.values;
  return <Link to={`/billing/invoices/${invoiceID}/details`}>{value}</Link>;
};

export const InvoicesTable = ({ useData, searchParams }) => {
  const exportContent = () => <ExportToCSVButton />;

  const invoiceNumber = searchParams.get('invoiceID');
  const invoiceStartDate = searchParams.get('invoiceStartDate');
  const invoiceEndDate = searchParams.get('invoiceEndDate');
  const invoiceDueStartDate = searchParams.get('invoiceDueStartDate');
  const invoiceDueEndDate = searchParams.get('invoiceDueEndDate');
  const filterData = {
    reference_number: invoiceNumber,
    date_from: invoiceStartDate,
    date_to: invoiceEndDate,
    date_due_from: invoiceDueStartDate,
    date_due_to: invoiceDueEndDate,
  };
  const columns = useMemo(
    () => [
      {
        id: 'invoiceID',
        Header: '',
        accessor: 'uuid',
      },
      {
        Header: 'Invoice ID',
        accessor: 'reference_number',
        className: 'col-md-3',
        Cell: renderInvoiceNumber,
      },
      {
        Header: 'Invoice Date',
        accessor: 'date_created',
        className: 'col-md-1',
      },
      {
        Header: 'Due Date',
        accessor: 'date_due',
        className: 'col-md-1',
      },
      {
        Header: 'Total',
        accessor: 'total',
        className: 'col-md-1',
      },
      {
        Header: 'Traffic',
        accessor: 'traffic',
        className: 'col-md-1',
      },
      {
        Header: 'Numbers',
        accessor: 'numbers',
        className: 'col-md-1',
      },
      {
        id: 'action',
        Header: 'Action',
        className: 'col-md-2',
        Cell: renderActionsCell,
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Invoices</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          hiddenColumns="invoiceID"
          exportContent={exportContent}
        />
      </Card.Body>
    </Card>
  );
};
